import axios from 'axios';
import store from '../index';

const state = {
	items: [],
	item: [],
	index: '',
	sortBy: '',
	sortDesc: '',
	setting: {},
	enableAgents: false,
};

const getters = {
	getItems: state => {
		return state.items;
	},
	getItem: state => {
		return state.item;
	},
	getIndex: state => {
		return state.index;
	},
	getSortBy: state => {
		return state.sortBy;
	},
	getSortDesc: state => {
		return state.sortDesc;
	},
	getSetting: state => {
		return state.setting;
	},
};

const actions = {
	asyncFetchData: async (context, settings) => {
		context.commit('setSetting', settings);
		const { sortBy, sortDesc, page, itemsPerPage } = settings.options;
		let url = 'returns';
		context.commit('setSortDesc', sortDesc[0]);
		context.commit('setSortBy', sortBy[0]);
		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						sortBy: sortBy[0],
						sortDesc: sortDesc[0],
						page: page,
						itemsPerPage: itemsPerPage,
						filters: settings.filters ? settings.filters : '',
						search: settings.search,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)

			.then(res => {
				//console.log(res.data.pagination);
				context.commit('setItems', res.data.data);
				return res.data.pagination;
				//resolve(res);
			})
			.catch(err => {
				console.log('errore', err);
				/*if (err.response.status === 401) {

                        //this.setLogout();
                        context.commit('profile/setLogout', {}, {root: true})
                        this.$router.push('/login')
                    }
                    throw Error(err.response.status + ":Posts Not Found");*/
			});
	},

	destroyData: context => {
		context.commit('setItems', []);
		context.commit('setItem', []);
		context.commit('setIndex', '');
	},
	saveData: (context, payload) => {
		let url = 'auth/register';

		return new Promise((resolve, reject) => {
			context.commit('settings/setErrors', {}, { root: true });
			axios
				.post(`${context.rootGetters['settings/getUrl']}${url}`, payload, { headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` } })

				.then(res => {
					//this.asyncFetchUsers();
					context.dispatch('asyncFetchUsers');

					resolve(res.data);
				})
				.catch(err => {
					const storeError = {
						code: err.response.status,
						statusText: err.response.statusText,
						errors: err.response.data.error,
						message: err.response.data.message,
					};
					//console.log(storeError);
					context.commit('settings/setErrors', storeError, { root: true });
					if (err.response.status === 401) {
						this.$router.push('/login');
					}
					reject(storeError);
				});
		});
	},

	// dettaglio di un reso (pagina /returns/:id); null se non esiste o e' di un altro merchant
	detail: async (context, id) => {
		return await axios
			.get(`${context.rootGetters['settings/getUrl']}returns/${id}`, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
			})
			.then(result => (result.data ? result.data.data : null))
			.catch(() => null);
	},
	edit: async (context, payload) => {
		let url = `orders/${payload.id}`;
		console.log(payload);
		return await axios
			.get(`${context.rootGetters['settings/getUrl']}${url}`, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
				'Content-Type': 'application/json',
			})
			.then(result => {
				return result.data;
			})
			.catch(error => {
				console.log(error.response.data);
				console.log(error.message);
			});
	},

	getItems: async (context, payload) => {
		let url = `orders/get-data/${payload.ids}`;

		return await axios
			.get(`${context.rootGetters['settings/getUrl']}${url}`, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
				'Content-Type': 'application/json',
			})
			.then(result => {
				return result.data;
			})
			.catch(error => {
				console.log(error.response.data);
				console.log(error.message);
			});
	},
};

const mutations = {
	setItems: (state, value) => {
		state.items = value;
	},
	setItem: (state, value) => {
		state.item = value;
	},
	setIndex: (state, value) => {
		state.index = value;
	},
	setSortBy: (state, value) => {
		state.sortBy = value;
	},
	setSortDesc: (state, value) => {
		state.sortDesc = value;
	},
	setSetting: (state, value) => {
		state.setting = value;
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
